<div class="container  fw-b ">
  <app-linker-route [headingName]="headingName" [linkerRouteItems]="linkerRouteItems"></app-linker-route>
</div>
<div class="container profile-container">
  <profile-layout [data]="profileData"></profile-layout>
</div>